export enum HoehereBeitraegeTyp {
    DEAKTIVIERT = 'DEAKTIVIERT',
    AKTIVIERT = 'AKTIVIERT',
    AKTIVIERT_AUSZAHLUNG_INSTITUTION = 'AKTIVIERT_AUSZAHLUNG_INSTITUTION'
}
